import { render, staticRenderFns } from "./orderMang.vue?vue&type=template&id=2f5ac7d8&scoped=true&"
import script from "./orderMang.vue?vue&type=script&lang=js&"
export * from "./orderMang.vue?vue&type=script&lang=js&"
import style0 from "./orderMang.vue?vue&type=style&index=0&id=2f5ac7d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ac7d8",
  null
  
)

export default component.exports